import { getData } from '../../Survey/helpers/fetch_services';

function buildLearningPackageQuery({ version } = {}) {
  if (version == null || version === '') {
    return '';
  }

  const params = new URLSearchParams();
  params.set('guidance_version', version);
  return `?${params.toString()}`;
}

/** Loads L&D package config from `GET learning-development/:packageId`. */
export async function fetchLearningPackage(packageId, { version } = {}) {
  const query = buildLearningPackageQuery({ version });
  const result = await getData(`learning-development/${packageId}${query}`);

  if (result?.data) {
    return result.data;
  }

  throw new Error(result?.message || 'Unable to load learning package.');
}
